export default __webpack_public_path__ + "static/helped-people-142b6f398a1cea007e71c9ec0e8a28e4.png";